<template>
  <b-card>
    <div>
      <h4 class="text-body">
        <feather-icon icon="LayersIcon" size="16" /> Merge Existing Segments
      </h4>
      <p class="text-muted mb-2">
        Combine existing segments to create a super segment
      </p>
    </div>

    <div>
      <div
        v-for="(segment) in selectedSegments"
        :key="segment.id"
        class="bg-light rounded d-flex align-items-center justify-content-between"
        style="gap: 12px; padding: 8px; margin-bottom: 2px;"
      >
        <div>
          <b-badge>{{ segment.name }}</b-badge>
          <span class="text-muted small ml-1"
            >{{ segment.usersCount }} clients</span
          >
        </div>

        <div class="d-flex align-items-center" style="gap: 8px">
          <!-- <div
            class="d-flex align-items-center"
            v-if="
              selectedSegments.length > 1 && idx < selectedSegments.length - 1
            "
          >
            <b-form-checkbox
              switch
              v-model="segment.logic"
              @change="(val) => $emit('toggleSegmentLogic', segment.id, val)"
            />
            <span class="text-uppercase small" style="display: inline-block; width: 30px;">
              {{ segment.logic ? "OR" : "AND" }}
            </span>
          </div> -->
          <b-button
            variant="link"
            size="sm"
            class="text-danger"
            @click="$emit('removeSegment', segment.id)"
          >
            <feather-icon icon="TrashIcon" size="16" />
          </b-button>
        </div>
      </div>
    </div>

    <b-form-group class="mt-2">
      <b-form-select
        v-model="selectedId"
        :options="availableSegments"
        @change="(val) => $emit('handleSegmentSelect', val, allSegments)"
        :placeholder="'Select a segment...'"
      />
    </b-form-group>
  </b-card>
</template>

<script>
import {
  BCard,
  BListGroup,
  BListGroupItem,
  BButton,
  BBadge,
  BFormCheckbox,
  BFormGroup,
  BFormSelectOption,
  BFormSelect,
} from "bootstrap-vue";
import { arrayProp, numberProp } from "@/helpers/props";
import { mapState, mapActions } from "vuex";

export default {
  props: {
    selectedSegments: arrayProp(),
    selectedId: numberProp(),
  },
  components: {
    BCard,
    BListGroup,
    BListGroupItem,
    BButton,
    BBadge,
    BFormCheckbox,
    BListGroupItem,
    BFormGroup,
    BFormSelectOption,
    BFormSelect,
  },
  data() {
    return {
      allSegments: [],
    };
  },
  computed: {
    availableSegments() {
      const selectedIds = this.selectedSegments.map((s) => s.id);
      return this.allSegments
        .filter((s) => !selectedIds.includes(s.id))
        .map((s) => ({
          value: s.id,
          text: `${s.name} (${s.usersCount} clients)`,
        }));
    },
  },
   async mounted() {
    await this.fetchSegmentList();
  },
  methods: {
     ...mapActions({
      getSegmentsList: "segment/list/getSegmentsList",
     }),
     async fetchSegmentList() {
      const data = await this.getSegmentsList({
        limit: 100,
      });
       this.allSegments = data.data.map(i => {
         return {
           ...i,
          logic: false
        }
      })
    },
  },
 
};
</script>
